import { apiGet, apiPut, apiPost } from "./client";
import type { AiProviderConfig } from "@ceo-cmd/shared";

export type { AiProviderConfig };

export async function listAiProviders(): Promise<AiProviderConfig[]> {
  const res = await apiGet<{ providers: AiProviderConfig[] }>("/api/ai-providers");
  return res.providers ?? [];
}

export async function updateAiProvider(
  id: string,
  updates: Partial<AiProviderConfig>,
): Promise<AiProviderConfig> {
  const res = await apiPut<{ provider: AiProviderConfig }>(
    `/api/ai-providers/${id}`,
    updates,
  );
  return res.provider;
}

export async function testAiProvider(
  id: string,
  config?: { apiKey?: string; baseUrl?: string; model?: string },
): Promise<{ success: boolean; response: string }> {
  return apiPost<{ success: boolean; response: string }>(
    `/api/ai-providers/${id}/test`,
    config ?? {},
  );
}
